export const littleFingerRightForUs = (ctx: CanvasRenderingContext2D, color: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.moveTo(218, 150) // 左上
  ctx.quadraticCurveTo(170, 413, 321, 590) // 下＿ベルトヘリ革の左
  ctx.quadraticCurveTo(277, 516, 263, 458)
  ctx.quadraticCurveTo(265, 440, 272, 427)
  ctx.quadraticCurveTo(222, 292, 241, 165)
  ctx.quadraticCurveTo(240, 152, 226, 147) // 頂点
  ctx.quadraticCurveTo(218, 150, 218, 150) // 左上
  // ctx.quadraticCurveTo() //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const littleFingerLeftForUs = (ctx: CanvasRenderingContext2D, color: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.moveTo(218, 150) // 上
  ctx.quadraticCurveTo(182, 287, 213, 401) //
  ctx.quadraticCurveTo(234, 498, 320, 589) // 左下
  ctx.quadraticCurveTo(253, 449, 274, 424) // 右下
  ctx.quadraticCurveTo(252, 370, 247, 333) // 指又頂点_小指・薬指間_右
  ctx.quadraticCurveTo(236, 318, 224, 324) // 指又頂点_小指・薬指間_中央
  ctx.quadraticCurveTo(214, 327, 206, 318) //
  ctx.quadraticCurveTo(201, 226, 218, 150) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
